import styled from 'styled-components';

export const ProductCardContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'config',
})<{
  config?: {
    // Layout
    flexDirection?: string;
    flexDirectionDesktop?: string;
    contentPosition?: 'left' | 'right';
    mobileLayout?: 'horizontal' | 'vertical';

    // Styling
    backgroundColor?: string;
    textColor?: 'snowwhite' | 'seedgreen';
    borderRadius?: string;
    padding?: string;
    gap?: string;

    // Container constraints
    width?: string;
    maxWidth?: string;
    minWidth?: string;
    height?: string;
    maxHeight?: string;
    minHeight?: string;
    overflow?: string;

    // Theme presets
    theme?: 'default' | 'compact' | 'featured';
  };
}>`
  display: flex;
  height: ${({ config }) => config?.height || '375px'};
  padding: var(--spacing-16);
  /* Container constraints */
  ${({ config }) => config?.width && `width: ${config.width};`}
  ${({ config }) => config?.maxWidth && `max-width: ${config.maxWidth};`}
  ${({ config }) => config?.minWidth && `min-width: ${config.minWidth};`}
  ${({ config }) => config?.maxHeight && `max-height: ${config.maxHeight};`}
  ${({ config }) => config?.minHeight && `min-height: ${config.minHeight};`}
  ${({ config }) => config?.overflow && `overflow: ${config.overflow};`}
  ${({ config }) =>
    config?.borderRadius && `border-radius: ${config.borderRadius};`}
  ${({ config }) => config?.padding && `padding: ${config.padding};`}

  gap: ${({ config }) => config?.gap || '16px'};
  align-items: center;

  flex: 1 1 0;
  border-radius: ${({ config }) => config?.borderRadius || 'var(--radius-md)'};
  background: ${({ config }) =>
    config?.backgroundColor || 'var(--fill-primary)'};
  flex-direction: ${({ config }) => {
    if (config?.flexDirection) return config.flexDirection;
    if (config?.contentPosition === 'left') return 'row';
    if (config?.contentPosition === 'right') return 'row-reverse';
    return 'row';
  }};
  color: ${({ config }) => {
    const colorValue = config?.textColor;
    if (colorValue === 'snowwhite' || colorValue === 'seedgreen') {
      return `var(--color--${colorValue})`;
    }
    return colorValue || 'inherit';
  }};

  /* Desktop in-between layout overrides */
  @media (min-width: 1024px) and (max-width: 1280px) {
    #add-to-cart-button,
    #digioh-vs-out-of-stock-cta-button {
      min-width: unset;
    }
  }
  /* Mobile layout overrides */
  @media (max-width: 1024px) {
    flex-direction: ${({ config }) => {
      if (config?.mobileLayout === 'horizontal') {
        return config?.contentPosition === 'left' ? 'row' : 'row-reverse';
      }
      return 'column';
    }};
    height: auto;
    min-height: 200px;
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    height: auto;
    min-height: 360px;
  }

  @media (min-width: 1025px) and (max-width: 1200px) {
    height: auto;
    min-height: 375px;
  }

  @media (min-width: 1025px) {
    padding: var(--spacing--x2, 16px);
    flex-direction: ${({ config }) => {
      if (config?.flexDirectionDesktop) return config.flexDirectionDesktop;
      if (config?.contentPosition === 'left') return 'row';
      if (config?.contentPosition === 'right') return 'row-reverse';
      return 'row';
    }};
  }

  /* IMPORTANT: These class-specific rules must come LAST to override general rules above */

  /* Grid product heights now controlled by ProductsGrid container */

  /* Featured product cards: let FeaturedSectionContainer control heights */
  &.featured-product {
    height: 100%; /* Fill the container height */
  }
`;
